import { render, staticRenderFns } from "./MaxSize.vue?vue&type=template&id=fc25b3cc&scoped=true"
import script from "./MaxSize.vue?vue&type=script&lang=js"
export * from "./MaxSize.vue?vue&type=script&lang=js"
import style0 from "./MaxSize.vue?vue&type=style&index=0&id=fc25b3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc25b3cc",
  null
  
)

export default component.exports